import { ProductType } from "@repo/api";
import {
	AllowedChangesBooleanKey,
	setOverrideCanChangeAmlIdentification,
	setOverrideCanChangeBeneficiaries,
	setOverrideCanChangeContactAddress,
	setOverrideCanChangeElectronicContacts,
	setOverrideCanChangeEmployerOrClientContribution,
	setOverrideCanChangeInvestmentStrategy,
	setOverrideCanChangeIsEmployerContributing,
	setOverrideCanChangeTaxOptimum,
	setOverrideCanChengeInflationProgram,
	setOverrideHasAnyFailedChanges,
	setOverrideIsAmlFulfilled,
	setOverrideIsBankIdIdentificationRequired,
	setOverrideIsClientIdentified,
} from "@repo/logic";

export const EMPTY_OVERRIDES: Partial<Record<AllowedChangesBooleanKey, boolean>> = {};

 
type BooleanFlag = {
	key: AllowedChangesBooleanKey;
	label: string;
	visibleOnlyForProductTypes?: readonly ProductType[];
};

const PENSION_PRODUCT_TYPES = [ProductType.Uf, ProductType.Pf] as const;

export const BOOLEAN_FLAGS: BooleanFlag[] = [
	{ key: AllowedChangesBooleanKey.CanChangeEmployerOrClientContribution, label: "Employer/Client Contribution" },
	{ key: AllowedChangesBooleanKey.CanChangeInvestmentStrategy, label: "Investment Strategy" },
	{ key: AllowedChangesBooleanKey.CanChangeTaxOptimum, label: "Tax Optimum" },
	{
		key: AllowedChangesBooleanKey.CanChangeAmlIdentification,
		label: "AML Identification",
		visibleOnlyForProductTypes: PENSION_PRODUCT_TYPES,
	},
	{ key: AllowedChangesBooleanKey.CanChangeContactAddress, label: "Contact Address" },
	{ key: AllowedChangesBooleanKey.CanChangeElectronicContacts, label: "Electronic Contacts" },
	{ key: AllowedChangesBooleanKey.CanChangeIsEmployerContributing, label: "Is Employer Contributing" },
	{ key: AllowedChangesBooleanKey.CanChengeInflationProgram, label: "Inflation Program" },
	{ key: AllowedChangesBooleanKey.CanChangeBeneficiaries, label: "Beneficiaries" },
	{
		key: AllowedChangesBooleanKey.IsClientIdentified,
		label: "Client Identified",
		visibleOnlyForProductTypes: PENSION_PRODUCT_TYPES,
	},
	{
		key: AllowedChangesBooleanKey.IsBankIdIdentificationRequired,
		label: "BankID Identification Required",
		visibleOnlyForProductTypes: PENSION_PRODUCT_TYPES,
	},
	{
		key: AllowedChangesBooleanKey.IsAmlFulfilled,
		label: "AML Fulfilled",
		visibleOnlyForProductTypes: PENSION_PRODUCT_TYPES,
	},
	{ key: AllowedChangesBooleanKey.HasAnyFailedChanges, label: "Has Any Failed Changes" },
];

export const getApplicableBooleanFlags = (productType?: ProductType): BooleanFlag[] =>
	BOOLEAN_FLAGS.filter(
		({ visibleOnlyForProductTypes }) =>
			visibleOnlyForProductTypes === undefined ||
			(productType !== undefined && visibleOnlyForProductTypes.some((visibleProductType) => visibleProductType === productType)),
	);

export const OVERRIDE_ACTIONS = {
	[AllowedChangesBooleanKey.CanChangeEmployerOrClientContribution]: setOverrideCanChangeEmployerOrClientContribution,
	[AllowedChangesBooleanKey.CanChangeInvestmentStrategy]: setOverrideCanChangeInvestmentStrategy,
	[AllowedChangesBooleanKey.CanChangeTaxOptimum]: setOverrideCanChangeTaxOptimum,
	[AllowedChangesBooleanKey.CanChangeAmlIdentification]: setOverrideCanChangeAmlIdentification,
	[AllowedChangesBooleanKey.CanChangeContactAddress]: setOverrideCanChangeContactAddress,
	[AllowedChangesBooleanKey.CanChangeElectronicContacts]: setOverrideCanChangeElectronicContacts,
	[AllowedChangesBooleanKey.CanChangeIsEmployerContributing]: setOverrideCanChangeIsEmployerContributing,
	[AllowedChangesBooleanKey.CanChengeInflationProgram]: setOverrideCanChengeInflationProgram,
	[AllowedChangesBooleanKey.CanChangeBeneficiaries]: setOverrideCanChangeBeneficiaries,
	[AllowedChangesBooleanKey.IsClientIdentified]: setOverrideIsClientIdentified,
	[AllowedChangesBooleanKey.IsBankIdIdentificationRequired]: setOverrideIsBankIdIdentificationRequired,
	[AllowedChangesBooleanKey.IsAmlFulfilled]: setOverrideIsAmlFulfilled,
	[AllowedChangesBooleanKey.HasAnyFailedChanges]: setOverrideHasAnyFailedChanges,
} as const;